import { CheckoutLayout } from '../checkout/CheckoutLayout'

export const CatalogPage = ({
    title,
    lead,
    children,
}: {
    title: string
    lead: string
    children: React.ReactNode
}) => (
    <CheckoutLayout>
        <section className="mx-auto w-full max-w-4xl px-6 py-16">
            <div className="mb-10 flex flex-col gap-2">
                <h1 className="text-4xl font-bold text-brand-dark">{title}</h1>
                <p className="text-lg text-brand-gray">{lead}</p>
            </div>
            {children}
        </section>
    </CheckoutLayout>
)

export const CatalogCard = ({
    title,
    subtitle,
    meta,
    action,
}: {
    title: string
    subtitle?: string
    meta?: React.ReactNode
    action: React.ReactNode
}) => (
    <div className="flex w-full flex-col gap-3 rounded-lg border border-slate-200 bg-white p-5">
        <div className="flex flex-col gap-1">
            <h2 className="text-lg font-semibold text-brand-dark">{title}</h2>
            {subtitle && <p className="text-sm text-brand-gray">{subtitle}</p>}
        </div>
        {meta}
        <div className="mt-auto pt-2">{action}</div>
    </div>
)
